module.exports = __webpack_public_path__ + "img/37b0056afa0b188d2b41db364bc794e2.svg";